import React, { Fragment, useEffect, useState, useMemo, useRef } from 'react'
import qs from 'query-string'
import { SRLWrapper, useLightbox } from 'simple-react-lightbox'
import { animate } from 'motion'
import parse from 'html-react-parser'
import { ErrorBoundary } from 'react-error-boundary'
import * as Papa from 'papaparse'
import $ from 'jquery'

// import '../../scripts/fm.js'
import useWindowDimensions from '../../hooks/useWindowDimensions';
import ProductVideo from '../ProductVideo/ProductVideo'
import VideoPlaceholder from '../ProductVideo/VideoPlaceholder'
import ShopMore from '../ShopMore/ShopMore'
import CaretUp from '../Caret/CaretUp'
import CaretDown from '../Caret/CaretDown'
import SizeGuide from '../SizeGuide/SizeGuide'

import Ribbon from '../Ribbon/Ribbon'
import BundleRibbon from '../SaleRibbon/BundleRibbon'
import Buy3Get30 from '../SaleRibbon/Buy3Get30'
import Buy3Get35 from '../SaleRibbon/Buy3Get35'
import Buy2Get25 from '../SaleRibbon/Buy2Get25'
import Plus30Ribbon from '../SaleRibbon/Plus30Ribbon'
import HalloweenThirtyOff from '../SaleRibbon/HalloweenThirtyOff'
import Fall2022drop2 from '../SaleRibbon/Fall2022drop2'
import Sale25OffRibbon from '../SaleRibbon/Sale25OffRibbon'
import Sale25Ribbon from '../SaleRibbon/Sale25Ribbon'
import FinalFew25Ribbon from '../SaleRibbon/FinalFew25Ribbon'
import FinalFewSaleRibbon from '../SaleRibbon/FinalFewSaleRibbon'
import SummerSaleRibbon from '../SaleRibbon/SummerSaleRibbon'
import WarehouseRibbon from '../SaleRibbon/WarehouseRibbon'
import Ribbon25InCart from '../SaleRibbon/Ribbon25InCart'
import BF30OffInCart from '../SaleRibbon/BF30OffInCart'
import BFExtra30OffInCart from '../SaleRibbon/BFExtra30OffInCart'
import Plus25Ribbon from '../SaleRibbon/Plus25Ribbon'
import Plus40Ribbon from '../SaleRibbon/Plus40Ribbon'
import TrunkSaleRibbonBasic from '../SaleRibbon/TrunkSaleRibbonBasic'
import UPF50 from '../Flags/UPF50'
import Schema from '../Schema/Schema'

import Embroidery from '../ProductOptions/Embroidery'

import { data } from '../../data/embroidery_data'

import {
    getUniqueListBy,
    insertUrlParam,
    slugify,
    unslugify,
    sizeSortFunc,
    convertToCurrency,
    getCookie,
    groupBy,
    trimLeadingSpaces,
} from '../../helpers/helpers'

import './Product.scss'

const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/'

function getSessionStorageOrDefault(key, defaultValue) {
    const stored = sessionStorage.getItem(key)
    if (!stored) {
        return defaultValue
    }
    return JSON.parse(stored)
}

const tagsArray = ['Buy2Get25', 'Buy3Get30', 'Buy3Get35', 'warehousesale']

let slug = window.location.href.split('/').pop()

slug = slug.split('?')[0]

// console.log('slug on PDP', slug)

const Product = React.memo(
    ({
        products,
        mainProduct,
        hiddenProduct,
        variants,
        variantIdOnLoad,
        allVariants,
        patternSlug,
    }) => {
        const [loaded, setLoaded] = useState(false)
        const [embroidery, setEmbroidery] = useState(false)
        const [currentProduct, setCurrentProduct] = useState(null)

        const inputRef = useRef(null)
        // console.log('variants in Product', variants)

        // console.log('products', products)

        const { windowWidth, windowHeight } = useWindowDimensions()

        // console.log('mainProduct in Product, variants', mainProduct, variants)

        // console.log('hiddenProduct in Product', hiddenProduct)

        let tags = []
        let currentProductTags = []
        let vendor = ''
        let productType = ''
        let intersection
        let productVideoUrl = ''
        let isSale25 = false
        let isSale30 = false
        let noGots = false
        let isUPF50 = false
        let isSwim = false
        let isMA = false
        let isSale40 = false

        if (
            hiddenProduct &&
            hiddenProduct.length > 0 &&
            hiddenProduct[0] &&
            hiddenProduct[0].metafields
        ) {
            let metafields = hiddenProduct[0].metafields
            productVideoUrl = metafields.find(
                (m) => m.key === 'url' && m.namespace === 'product_video'
            )?.value
        }

        // console.log('productVideoUrl', productVideoUrl)

        let currentVariants

        useEffect(() => {
            let currentProductFromVariants
            if (variantIdOnLoad) {
                currentProductFromVariants = products.filter((p) => {
                    let currentP = p.variants.map((v) => {
                        // console.log('v.id', v.id)
                        if (v.id.toString() === variantIdOnLoad.toString()) {
                            return p
                        }
                    })

                    currentP = currentP.filter((n) => n)
                    // console.log('currentP', currentP)
                    if (currentP && currentP.length > 0) {
                        return currentP[0]
                    }
                })
                if (
                    currentProductFromVariants &&
                    currentProductFromVariants.length > 0
                ) {
                    console.log(
                        'currentProductFromVariants',
                        currentProductFromVariants
                    )
                    setCurrentProduct(currentProductFromVariants)

                    vendor = currentProductFromVariants[0].vendor

                    productType = currentProductFromVariants[0].product_type

                    console.log('productType', productType)

                    // if (productType === 'Pajamas') {
                    //     console.log('pajamas', productType)
                    //     isSale30 = true

                    //     console.log('isSale30 here', isSale30)
                    // }

                    // if (vendor === 'Monica + Andy') {
                    //     isMA = true
                    // }

                    tags = currentProductFromVariants[0].tags

                    console.log('tags', tags)

                    // if (tags.includes('UPF50')) {
                    //     isUPF50 = true
                    // }
                    // if (tags.includes('swimwear2023')) {
                    //     isSwim = true
                    // }

                    if (tags.includes('fallsavingsevent2023')) {
                        isSale30 = true
                    }
                    // if (tags.includes('disney100') || tags.includes('Disney100')) {
                    //     setIsDisney(true)
                    // } else {
                    //     intersection = tagsArray.filter((element) =>
                    //         tags.includes(element)
                    //     )[0]
                    //     // console.log('tags here', tags, intersection)

                    //     if (intersection && intersection !== '') {
                    //         setIsBundle(intersection)
                    //     } else {
                    //         setIsBundle(false)
                    //     }
                    // }



                }
                // if (
                //     currentProductFromVariants &&
                //     currentProductFromVariants.length > 0
                // ) {

                // }
            }
        }, [variantIdOnLoad])

        useEffect(() => {
            if (currentProduct && currentProduct[0]) {
                currentProductTags = currentProduct[0].tags
                intersection = tagsArray.filter((element) =>
                    currentProductTags.includes(element)
                )[0]
                // console.log('intersection', intersection, hiddenProductTags)
                currentVariants = currentProduct[0].variants

                const productType = currentProduct[0].product_type

                console.log('currentProductTags', currentProductTags)
                if (currentProductTags.includes('no-gots')) {
                    noGots = true
                }
                // if (currentProduct && currentProduct.length > 0) {
                //     tags = currentProduct[0].tags
                // }
                if (currentProductTags.includes('UPF50')) {
                    isUPF50 = true
                }
                if (currentProductTags.includes('swimwear2023')) {
                    isSwim = true
                }
                if (currentProduct[0].vendor === 'Monica + Andy') {
                    isMA = true
                }
                if (currentProductTags.includes('fallsavingsevent2023')) {
                    isSale30 = true
                    console.log('isSale30 here', isSale30)
                }

                // if (productType === 'Pajamas') {

                //     isSale30 = true

                //     console.log('pajamas here here', productType, isSale30)
                // }


            }
        }, [currentProduct])

        // if (mainProduct && mainProduct[0]) {

        //     let mainProductTags = mainProduct[0].tags

        //     const productType = mainProduct[0].product_type



        //     // if (productType === 'Pajamas') {

        //     //     isSale30 = true

        //     //     console.log('pajamas here here mainproduct', productType, isSale30)
        //     // }

        //         // if (mainProductTags.includes('fallsavingsevent2023')) {
        //         //     isSale30 = true
        //         // }



        //         // if (mainProductTags.includes('no-gots')) {
        //         //     noGots = true
        //         // }

        //         // // if (mainProductTags.includes('UPF50')) {
        //         // //     isUPF50 = true
        //         // // }
        //         // // if (mainProductTags.includes('swimwear2023')) {
        //         // //     isSwim = true
        //         // // }

        //         // if (mainProduct[0].vendor === 'Monica + Andy') {
        //         //     isMA = true
        //         // }



        // }

        console.log('currentProduct', currentProduct, currentVariants)

        const sortedColors = useRef(null)

        let embroideryProduct = []

        // let embroidery = false

        let embroideredProducts = data.embroidery.products

        // console.log('embroideredProducts', embroideredProducts)

        if (currentProduct && currentProduct.length > 0) {
            tags = currentProduct[0].tags

            if (tags.includes('fallsavingsevent2023')) {
                isSale30 = true
            }


        }

        let initialVariant = allVariants.filter((v) => {
            // console.log('v.id', v.id, 'variantIdOnLoad', variantIdOnLoad)
            if (variantIdOnLoad) {
                return v.id.toString() === variantIdOnLoad.toString()
            }
            return null
        })

        // console.log('initialVariant', initialVariant)

        // if we don't have a variantId in the URL, we'll use the first one
        if (initialVariant.length === 0) {
            initialVariant = [variants[0]]
        }

        // console.log('mainProduct, initialVariant', mainProduct, initialVariant)

        useEffect(() => {
            if (embroideredProducts && embroideredProducts.length) {
                let obj = embroideredProducts.find(
                    (o) =>
                        o.productHandle === mainProduct[0].handle.split('_')[0] ||
                        (hiddenProduct && hiddenProduct[0]
                            ? o.productHandle === hiddenProduct[0].handle
                            : currentProduct && currentProduct[0] ? o.productHandle === currentProduct[0].handle : null)
                )

                console.log('obj', obj)
                if (
                    (obj && obj.productHandle !== '') ||
                    (obj && obj.productHandle !== null)
                ) {
                    setEmbroidery(true)
                }
            }

            if (
                initialVariant &&
                initialVariant[0].inventory_quantities &&
                initialVariant[0].inventory_quantities['61523329086']
            ) {
                // console.log(
                //     'initialVariant.inventory_quantities',
                //     initialVariant[0].inventory_quantities['1113980954']
                // )
                if (
                    initialVariant[0].inventory_quantities['61523329086'] === 0
                ) {
                    setEmbroidery(false)
                }
            }
        }, [])

        if (!embroidery) {
            sessionStorage.removeItem('productOptions')
        }

        let productDescription =
            hiddenProduct && hiddenProduct.length > 0
                ? hiddenProduct[0].body_html
                : mainProduct[0].body_html

        let productDescriptionText = productDescription.split('::::')[0]
        productDescriptionText = parse(productDescriptionText)
        let valueProps = productDescription.split('::::')[1]

        let initialColor = ''

        if (patternSlug && patternSlug !== '') {
            // console.log('patternSlug here', patternSlug)
            initialColor = unslugify(patternSlug)
        } else if (initialVariant[0].initial_color) {
            // console.log('initialVariant[0].initial_color', initialVariant[0].initial_color)
            initialColor = initialVariant[0].initial_color.replace(/\//g, ' ')

        }

        const [currentColor, setCurrentColor] = useState(initialColor)

        const [colors, setColors] = useState({
            basicColors: [],
            limitedColors: [],
            trunkSaleColors: [],
        })

        // console.log('currentColor', currentColor)

        const [position, setPosition] = useState({
            pos: 0,
            index: 0,
        })
        const [video, setVideo] = useState(
            productVideoUrl ? productVideoUrl : ''
        )
        const [videoIsActive, setVideoIsActive] = useState(false)
        const [videoIsPlaying, setVideoIsPlaying] = useState(false)

        const videoRef = useRef(null)

        const [sizes, setSizes] = useState([])

        const [currentSize, setCurrentSize] = useState({
            size: '',
            variantId: '',
            sku: '',
        })

        const [quantity, setQuantity] = useState(1)
        const [mainImageStyle, setMainImageStyle] = useState({
            backgroundImage: '',
            backgroundPosition: '0% 0%',
        })

        const [hasSwatches, setHasSwatches] = useState(true)

        const { openLightbox, closeLightbox } = useLightbox()

        const [isRibbon, setIsRibbon] = useState(false)
        const [isFinalFew, setIsFinalFew] = useState(false)
        const [isTrunkSale, setIsTrunkSale] = useState(false)
        const [isDailyDeal, setIsDailyDeal] = useState(false)
        const [isBundle, setIsBundle] = useState(false)

        const bundleRibbons = {
            Buy2Get25: <Buy2Get25 />,
            Buy3Get30: <Buy3Get30 />,
            Buy3Get35: <Buy3Get35 />,
            // warehousesale: <Plus30Ribbon />,
            // dailydeal: <Ribbon />,
        }

        const [soldOutSelected, setSoldOutSelected] = useState({
            isSoldOut: false,
            variantId: '',
            productTitle: '',
            variantColor: '',
            variantSize: '',
            variantSku: '',
        })

        const [productOptions, setProductOptions] = useState(
            getSessionStorageOrDefault('productOptions', {
                embroidery: false,

                embroideryFont: {},
                embroideryColor: '',
                embroideryText: '',
                embroideryCharacterLimit: 20,
                embroideryPrice: 15,
                embroiderySubmitted: false,
                embroideryVariantId: '',
            })
        )

        useEffect(() => {
            // console.log('currentProduct in useEffect', currentProduct)
            if (
                currentProduct &&
                currentProduct[0] &&
                currentProduct[0].vendor === 'Monica + Andy'
            ) {
                if (
                    currentProduct[0].title.indexOf('TRUNK SALE') > -1 ||
                    currentProduct[0].title.indexOf('FINAL FEW') > -1 ||
                    currentProduct[0].title.indexOf('SALE') > -1
                ) {
                    // console.log('isTrunkSale')
                    setIsTrunkSale(true)
                    setIsRibbon(false)
                }

                // else if (
                //     currentProduct &&
                //     currentProduct.length > 0 &&
                //     currentProductTags.indexOf('dailydeal') > -1
                // ) {
                //     setIsDailyDeal(true)
                // } else {
                //     console.log('isRibbon')

                //     setIsRibbon(true)
                // }
            }
        }, [currentProduct])

        if (
            variantIdOnLoad &&
            variantIdOnLoad.toString() !== productOptions.embroideryVariantId
        ) {
            // console.log('variantId does not match embroidery')
            sessionStorage.removeItem('productOptions')
        }

        const options = {
            settings: {
                overlayColor: 'rgba(248, 248, 248, 0.9)',
            },
        }

        const [embroideryError, setEmbroideryError] = useState(false)

        const [isDisney, setIsDisney] = useState(
            currentProduct &&
                currentProduct[0] &&
                currentProduct[0].tags.includes('Disney100')
        )

        console.log('isDisney', isDisney, currentProduct)

        const [isOptIn, setIsOptIn] = useState(true)

        useEffect(() => {
            let videoMetafield = mainProduct[0].metafields.filter((m) => {
                if (m.namespace === 'product_video' && m.key === 'url') {
                    return m.value
                }
                return null
            })

            if (videoMetafield.length > 0) {
                setVideo(videoMetafield[0].value)
            }
        }, [mainProduct])

        let allProductImages = products.map((p) => {
            // console.log('p.images_info', p.images_info)
            // console.log('p', p)

            let images = p.images_info.map((v, i) => {
                // console.log('v', v)
                // console.log('currentColor', currentColor)

                return {
                    imageSrc: v.src,
                    imageAlt: v.alt ? v.alt : slugify(currentColor),
                    position: v.position,
                    colorSlug: v.alt ? v.alt : '',
                    initial_color: v.alt ? unslugify(v.alt) : '',
                    id: v.id,
                    variantId: v.id,
                    productId: p.id,
                    price: p.price_max,
                    compareAtPrice: p.compare_at_price_max,
                }
            })
            return images
        })

        allProductImages = allProductImages.flat(1)

        // console.log('allProductImages', allProductImages)

        let matchingProductImages = allProductImages.filter((p) => {
            // console.log('p.initial_color', p.initial_color)
            // console.log('p in matchingProductImages', p)
            if (!hiddenProduct || hiddenProduct.length === 0) {
                return allProductImages
            }
            if (patternSlug && patternSlug !== '') {
                return p.initial_color.toString().toLowerCase() === unslugify(patternSlug).toString().toLowerCase()
            } else if (
                p.initial_color &&
                p.initial_color !== '' &&
                initialVariant[0].initial_color
            ) {
                // console.log(
                //     'here in matchingProductImages, initialVariant[0]',
                //     initialVariant[0]
                // )
                return (
                    p.initial_color.toString().toLowerCase() ===
                    initialVariant[0].initial_color.toString().toLowerCase()
                )
            }
            // if (!p.initial_color && !initialVariant[0].initial_color) {
            //     return p
            // }
            return null
        })

        console.log('matchingProductImages', matchingProductImages)

        if (matchingProductImages.length === 0) {

            console.log('matchingProductImages.length === 0')
            let match = mainProduct[0].variants[0]



            matchingProductImages = [
                {
                    imageSrc: match.image,
                    imageAlt: mainProduct[0].title,
                    position: 1,
                    colorSlug: match.initial_color,
                    initial_color: match.initial_color,
                    id: match.id,
                },
            ]
        }

        // console.log('matchingProductImages before uniq', matchingProductImages)

        matchingProductImages = getUniqueListBy(
            matchingProductImages,
            'imageSrc'
        )

        // for classes + unsized items, use the first image
        if (mainProduct[0].product_type === 'Virtual Classes') {
            matchingProductImages = [matchingProductImages[0]]
        }

        // console.log('matchingProductImages after uniq', matchingProductImages)

        let matchingProduct = useMemo(() => [], [])
        let productImageSrc = ''

        if (variantIdOnLoad) {
            matchingProduct = variants.filter((v) => {
                return v.id.toString() === variantIdOnLoad.toString()
            })
            if (matchingProduct && matchingProduct.length) {
                productImageSrc = matchingProduct[0].image
            } else {
                matchingProduct = [mainProduct[0]]
                productImageSrc = matchingProductImages[0].imageSrc
            }
        } else if (patternSlug && patternSlug !== '') {

            console.log('patternSlug', patternSlug)
            // matchingProduct = [mainProduct[0]]
            matchingProduct = products.filter((p) => {

                console.log('p in matching', p)
                // return null
                if (p.options_with_values && p.options_with_values.length > 0) {
                    return p.options_with_values[0].values[0].title.toString().toLowerCase() === unslugify(patternSlug).toString().toLowerCase()
                }
                // return p.initial_color.toString().toLowerCase === unslugify(patternSlug).toString().toLowerCase()
            })

            if (matchingProduct && matchingProduct.length) {
                productImageSrc = matchingProduct[0].images_info[0].src
            } else {
                matchingProduct = [mainProduct[0]]
                productImageSrc = matchingProductImages[0].imageSrc
            }

            // if (matchingProduct && matchingProduct.length === 0) {
            //     matchingProduct = [mainProduct[0]]
            // }

            console.log('matchingProduct here', matchingProduct[0])
        } else {
            matchingProduct = [mainProduct[0]]

            if (variants && variants.image) {
                productImageSrc = variants[0].image
            } else {
                productImageSrc = matchingProductImages[0].imageSrc
            }
        }



        console.log('matchingProduct here, mainProduct', matchingProduct, mainProduct)

        // console.log(
        //     'productImageSrc, matchingProductImages',
        //     productImageSrc,
        //     matchingProductImages
        // )

        // productImages = getUniqueListBy(productImages, 'initial_color')

        let productTitle

        if (slug.indexOf('_') > -1) {
            // console.log('slug has underscore')
            let slugPattern = slug.split('_')[1]
            productTitle =
                hiddenProduct[0].title
        } else if (hiddenProduct && hiddenProduct[0]) {
            productTitle = hiddenProduct[0].title
        } else {
            productTitle = products[0].title
        }

        productTitle = productTitle.replace('SALE - ', '')
        productTitle = productTitle.replace('[hidden]', '')
        // console.log('productTitle here', productTitle)
        productTitle = productTitle.split('?')[0]

        // console.log('productTitle', productTitle)

        const [mainImage, setMainImage] = useState({
            src: productImageSrc,
            alt: productTitle ? productTitle : 'product image',
            initial_color:
                variants[0].initial_color ||
                mainProduct[0].options_with_values[0].values[0].title,
        })

        const [currentImages, setCurrentImages] = useState(
            matchingProductImages
        )



        const [currentPrice, setCurrentPrice] = useState({
            price:
                // currentProduct.price ||
                // currentProduct.price_max_usd ||
                // currentProduct.price_max ||
                matchingProduct[0].price ||
                matchingProduct[0].price_max ||
                mainProduct[0].price ||
                mainProduct[0].price_max_usd ||
                mainProduct[0].price_max ||
                hiddenProduct[0].price ||
                hiddenProduct[0].price_max_usd ||
                hiddenProduct[0].price_max ||
                variants[0].price,
            compareAtPrice: matchingProduct[0].compare_at_price || matchingProduct[0].compare_at_price_max
        })

        console.log('currentPrice.price', currentPrice.price)

        /* swatches */
        let swatches = useMemo(() => [], [])
        if (hiddenProduct && hiddenProduct.length > 0) {
            variants.map((v) => {
                if (v.initial_color && v.inventory_quantity > 0) {
                    swatches.push(v.initial_color)
                }
                return null
            })
        } else {
            variants.map((v) => {
                if (v.inventory_quantity > 0) {
                    swatches.push(v.initial_color)
                }
                return null
            })
        }

        // console.log('swatches before Set', swatches)
        swatches = [...new Set(swatches)]

        // console.log('swatches', swatches)

        let variantColors = []
        let basicColors = []
        let limitedColors = []
        let trunkSaleColors = []
        let sortedSwatches = []
        let defaultColors = []

        useEffect(() => {
            if (!swatches || swatches.length === 0) {
                setHasSwatches(false)
            }
        }, [swatches])

        useEffect(() => {
            if (!hiddenProduct || hiddenProduct.length === 0) {
                sortedSwatches = swatches.map((s) => {

                    return {
                        color: s,
                        colorType: 'basic',
                    }
                })
                // console.log('sortedSwatches no hidden', sortedSwatches)
                setColors(sortedSwatches)
            }
            let colorsUrl =
                'https://macollectionrank.s3.us-east-2.amazonaws.com/ma_evergreen_trunksale_colors.csv'
            ;(async () => {
                await Papa.parse(colorsUrl, {
                    download: true,
                    header: true,
                    complete: function (data) {
                        variantColors = data.data
                        // console.log('variantColors', variantColors)
                        products.map((p) => {
                            // console.log('p', p)
                            variantColors.map((c) => {
                                if (
                                    p.id.toString() === c.product_id.toString()
                                ) {
                                    // console.log('c', c)
                                    // if (
                                    //     c.product_id.toString() ===
                                    //         '6937138593854' ||
                                    //     p.id.toString() === '6937138593854'
                                    // ) {
                                    //     console.log('mint seersucker', c, p)
                                    // }
                                    if (
                                        c.basic_colors !== '' &&
                                        c.trunk_sale_colors === ''
                                    ) {
                                        basicColors.push(p)
                                    } else if (c.trunk_sale_colors !== '') {
                                        trunkSaleColors.push(p)
                                    }
                                }
                            })
                        })

                        // console.log('variantColors', variantColors)

                        // console.log('defaultColors', defaultColors)

                        let extraColors = [...basicColors, ...trunkSaleColors]

                        // eslint-disable-next-line
                        limitedColors = products.filter(
                            (x) => !extraColors.includes(x)
                        )

                        // console.log('limitedColors', limitedColors)

                        // console.log(
                        //     'basicColors, trunkSaleColors, limited Colors',
                        //     basicColors,
                        //     trunkSaleColors,
                        //     limitedColors
                        // )

                        // console.log(
                        //     'basicColors.variants[0].initial_color',
                        //     basicColors[0].variants[0].initial_color
                        // )

                        // eslint-disable-next-line

                        swatches.map((s) => {
                            if (basicColors && basicColors.length) {
                                basicColors.map((b) => {
                                    if (
                                        b.variants[0] &&
                                        b.variants[0].initial_color &&
                                        b.variants[0].initial_color.toString() ===
                                            s.toString()
                                    ) {
                                        // console.log(
                                        //     'b.variants[0].initial_color.toString(), s',
                                        //     b.variants[0].initial_color.toString(),
                                        //     s.toString()
                                        // )
                                        sortedSwatches.push({
                                            color: s,
                                            colorType: 'basic',
                                        })
                                    }
                                    return null
                                })
                            }
                            if (trunkSaleColors && trunkSaleColors.length) {
                                trunkSaleColors.map((t) => {
                                    if (
                                        t.variants[0] &&
                                        t.variants[0].initial_color &&
                                        t.variants[0].initial_color.toString() ===
                                            s.toString()
                                    ) {
                                        sortedSwatches.push({
                                            color: s,
                                            colorType: 'trunkSale',
                                        })
                                    }
                                    return null
                                })
                            }
                            if (limitedColors && limitedColors.length) {
                                limitedColors.map((l) => {
                                    // console.log('l', l)
                                    if (
                                        l.variants[0] &&
                                        l.variants[0].initial_color &&
                                        l.variants[0].initial_color.toString() ===
                                            s.toString()
                                    ) {
                                        sortedSwatches.push({
                                            color: s,
                                            colorType: 'limited',
                                        })
                                    }
                                    return null
                                })
                            }
                            // if (defaultColors && defaultColors.length) {
                            //     defaultColors.map((d) => {
                            //         // console.log('l', l)
                            //         if (
                            //             d.variants[0] &&
                            //             d.variants[0].initial_color &&
                            //             d.variants[0].initial_color.toString() ===
                            //                 s.toString()
                            //         ) {
                            //             sortedSwatches.push({
                            //                 color: s,
                            //                 colorType: 'basic',
                            //             })
                            //         }
                            //         return null
                            //     })
                            // }

                        })

                        // console.log('sortedSwatches after Set', sortedSwatches)

                        if (
                            sortedSwatches.length === 0 ||
                            (sortedSwatches &&
                                sortedSwatches[0].color === 'undefined') ||
                            sortedSwatches[0].color === undefined
                        ) {
                            console.log('no swatches')
                            setColors('noSwatches')
                        } else {
                            sortedColors.current = getUniqueListBy(
                                sortedSwatches,
                                'color'
                            )

                            // let sorted = groupBy(sortedSwatches, 'colorType')
                            sortedColors.current = groupBy(
                                sortedColors.current,
                                'colorType'
                            )
                            console.log(
                                'sortedColors.current',
                                sortedColors.current
                            )

                            setColors({
                                basicColors: sortedColors.current.basic,
                                trunkSaleColors: sortedColors.current.trunkSale,
                                limitedColors: sortedColors.current.limited,
                                // defaultColors: sortedColors.current.default,
                            })
                        }

                        // console.log('colors', colors)
                    },
                })
            })()
        }, [])

        /* sizes */

        useEffect(() => {
            let initialSizes = []

            allVariants.map((v) => {
                let variantColorSlug = ''
                if (v.initial_color) {
                    variantColorSlug = slugify(v.initial_color)
                }
                let currentColorSlug = slugify(currentColor)

                // console.log('variantColorSlug, currentColorSlug', variantColorSlug, currentColorSlug)
                if (v.initial_size && variantColorSlug === currentColorSlug) {
                    initialSizes.push({
                        variantId: v.id,
                        inventory_quantity: v.inventory_quantity,
                        sku: v.sku,
                        productId: v.product_id,
                        price: v.price,
                        initial_size: v.initial_size,
                    })
                }
                return null
            })

            // console.log('initialSizes, allVariants, currentColor', initialSizes, allVariants, currentColor)

            if (initialSizes.length > 0) {
                let sortedSizeList = initialSizes.sort(sizeSortFunc)
                // console.log('sortedSizeList', sortedSizeList)

                sortedSizeList = getUniqueListBy(sortedSizeList, 'initial_size')

                sortedSizeList = sortedSizeList.filter(function (e) {
                    return e !== null && e !== undefined && e !== ''
                })

                if (sortedSizeList) {
                    setSizes(sortedSizeList)
                }
            } else {
                setCurrentSize({
                    size: 'nosize',
                    variantId: initialVariant[0].id,
                    sku: initialVariant[0].sku,
                })
                setSizes([])
            }
            // eslint-disable-next-line
        }, [])

        const handleImageClick = (
            colorSlug,
            initialColor,
            imageSrc,
            imageAlt,
            index
        ) => {
            closeLightbox()

            let imageSelected = document.querySelector('.image-selected')

            imageSelected.classList.remove('image-selected')

            // find matching image node; add class
            let matchingImageNode = document.querySelector(
                '[data-index="' + index + '"]'
            )
            matchingImageNode.classList.add('image-selected')

            setMainImage({
                src: imageSrc,
                alt: imageAlt ? imageAlt : 'product image',
                initial_color: initialColor,
            })

            setCurrentColor(initialColor)

            setPosition({
                ...position,
                index: index,
            })
        }

        const handlePrevClick = () => {
            if (position.index === 0) {
                return
            }
            if (position.index !== 0) {
                animate(
                    '#images-nav',
                    { y: position.pos + 90 },
                    { duration: 0.5 }
                ).finished.then(() => {
                    // console.log('prev click finished')
                    setMainImage({
                        src: currentImages[position.index - 1].imageSrc,
                        alt: currentImages[position.index - 1].imageAlt
                            ? currentImages[position.index - 1].imageAlt
                            : 'product image',
                        variantId: currentImages[position.index - 1].variantId,
                        initial_color:
                            currentImages[position.index - 1].initial_color,
                        price: currentImages[position.index - 1].price,
                        compareAtPrice:
                            currentImages[position.index - 1].compareAtPrice,
                    })
                    // setCurrentPrice({
                    //     price: currentImages[position.index - 1].price,
                    //     compareAtPrice:
                    //         currentImages[position.index - 1].compareAtPrice,
                    // })
                    setCurrentColor(
                        currentImages[position.index - 1].initial_color
                    )
                    setPosition({
                        pos: position.pos + 90,
                        index: position.index - 1,
                    })

                    // console.log(
                    //     'currentImages',
                    //     currentImages,
                    //     position.index - 1
                    // )
                    // update url param
                    insertUrlParam(
                        'variant',
                        currentImages[position.index - 1].id
                    )
                })
            }

            let matchingVariants = variants.filter((v) => {
                return (
                    v.initial_color ===
                    currentImages[position.index - 1].initial_color
                )
            })

            let matchingVariantSizes = []

            matchingVariants.map((v) => {
                matchingVariantSizes.push({
                    variantId: v.id,
                    inventory_quantity: v.inventory_quantity,
                    sku: v.sku,
                    productId: v.product_id,
                    price: v.price,
                    initial_size: v.initial_size,
                })
                return null
            })

            matchingVariantSizes = getUniqueListBy(
                matchingVariantSizes,
                'initial_size'
            )

            matchingVariantSizes.map((s) => {
                if (s.initial_size === currentSize) {
                    setCurrentSize(currentSize)
                }
                return null
            })

            setSizes(matchingVariantSizes)
        }

        const handleNextClick = () => {
            console.log(
                'position.index, productImages.length',
                position.index,
                currentImages.length
            )

            if (position.index === currentImages.length - 1) {
                return
            }

            let imageSelected = document.querySelector('.image-selected')

            let currentIndex = imageSelected.dataset.index

            currentIndex = parseInt(currentIndex)

            // console.log(
            //     'currentIndex, imageSelected',
            //     currentIndex,
            //     imageSelected,
            //     allProductImages
            // )

            imageSelected.classList.remove('image-selected')

            // find matching image node; add class
            let matchingImageNode = document.querySelector(
                '.nav-image[data-index="' + (currentIndex + 1) + '"]'
            )
            matchingImageNode.classList.add('image-selected')

            // console.log('currentImages', currentImages, position.index + 1)

            if (currentIndex !== currentImages.length) {
                animate(
                    '#images-nav',
                    { y: position.pos - 90 },
                    { duration: 0.5 }
                ).finished.then(() => {
                    // console.log('next click finished')
                    setMainImage({
                        src: currentImages[currentIndex + 1].imageSrc,
                        alt: currentImages[currentIndex + 1].imageAlt
                            ? currentImages[currentIndex + 1].imageAlt
                            : 'product image',
                        variantId: currentImages[currentIndex + 1].variantId,
                        initial_color:
                            currentImages[currentIndex + 1].initial_color,
                        price: currentImages[currentIndex + 1].price,
                        compareAtPrice:
                            currentImages[currentIndex + 1].compareAtPrice,
                    })
                    // setCurrentPrice({
                    //     price: currentImages[currentIndex + 1].price,
                    //     compareAtPrice:
                    //         currentImages[currentIndex + 1].compareAtPrice,
                    // })
                    setCurrentColor(
                        currentImages[currentIndex + 1].initial_color
                    )
                    setPosition({
                        pos: position.pos - 90,
                        index: currentIndex + 1,
                    })
                    // update url param
                    insertUrlParam(
                        'variant',
                        currentImages[currentIndex + 1].id
                    )
                })
            }

            let matchingVariants = variants.filter((v) => {
                return (
                    v.initial_color ===
                    currentImages[currentIndex + 1].initial_color
                )
            })

            let matchingVariantSizes = []

            matchingVariants.map((v) => {
                matchingVariantSizes.push({
                    variantId: v.id,
                    inventory_quantity: v.inventory_quantity,
                    sku: v.sku,
                    productId: v.product_id,
                    price: v.price,
                    initial_size: v.initial_size,
                })
                return null
            })

            matchingVariantSizes = getUniqueListBy(
                matchingVariantSizes,
                'initial_size'
            )

            matchingVariantSizes.map((s) => {
                if (s.initial_size === currentSize.size) {
                    setCurrentSize({
                        size: currentSize.size,
                        variantId: s.variantId,
                    })
                }
                return null
            })

            setSizes(matchingVariantSizes)
        }

        const handleSwatchClick = (swatchSlug, swatchTitle, index) => {
            let ele = document.getElementsByClassName('size size-selected')
            if (ele.length > 0) {
                ele[0].classList.remove('size-selected')
            }
            // console.log('swatch clicked', swatchSlug, swatchTitle)

            swatchTitle = swatchTitle.replace(/\//g, ' ')

            // console.log('swatchTitle', swatchTitle, currentColor)

            if (swatchTitle !== currentColor) {
                setCurrentColor(swatchTitle)
                setPosition({
                    ...position,
                    index: 0,
                })
            } else {
                setPosition({
                    ...position,
                    index: index,
                })
            }

            // console.log('allProductImages', allProductImages)

            let newImages = allProductImages.filter((n, i) => {
                // console.log('n.variantId', n.variantId)

                // console.log('n', n)
                if (n.initial_color) {
                    return (
                        slugify(n.initial_color).toLowerCase() ===
                        slugify(swatchTitle).toLowerCase()
                    )
                } else {
                    return i === index
                }
            })

            // console.log('newImages before unique', newImages)

            newImages = getUniqueListBy(newImages, 'imageSrc')

            // console.log('newImages after unique', newImages)

            setCurrentImages(newImages)

            let matchingVariants = allVariants.filter((v) => {
                return v.initial_color === swatchTitle
            })

            let matchingId = matchingVariants[0].id

            let currentProductFromVariants = products.filter((p) => {
                let currentP = p.variants.map((v) => {
                    // console.log('v.id', v.id)
                    if (v.id.toString() === matchingId.toString()) {
                        return p
                    }
                })
                return currentP[0]
            })

            setCurrentProduct(currentProductFromVariants)

            console.log('currentProduct in swatch click', currentProductFromVariants)

            let matchingV = variants.filter((v) => {
                return v.initial_color === swatchTitle
            })

            console.log('matchingV', matchingV)

            if (newImages && newImages.length > 0) {
                setMainImage({
                    src: newImages[0].imageSrc,
                    alt: newImages[0].imageAlt
                        ? newImages[0].imageAlt
                        : 'product image',
                    initial_color: newImages[0].initial_color,
                })
            } else {
                // console.log('matchingV', matchingV)
                setMainImage({
                    src: matchingV[0].image,
                    alt: slugify(swatchTitle),
                    initial_color: swatchTitle,
                })
                setCurrentImages([
                    {
                        imageSrc: matchingV[0].image,
                        imageAlt: slugify(swatchTitle),
                        initial_color: swatchTitle,
                    },
                ])
            }

            // let matchingProduct = []
            // products.filter((p) => {
            //     p.variants.map((v) => {
            //         if (v.id.toString() === matchingV[0].id.toString()) {
            //             matchingProduct.push(p)
            //         }
            //         return null
            //     })
            // })

            if (currentProductFromVariants && currentProductFromVariants[0]) {
                if (currentProductFromVariants[0].vendor === 'Monica + Andy') {
                    isMA = true
                }
            }

            if (
                currentProductFromVariants &&
                currentProductFromVariants[0] &&
                currentProductFromVariants[0].tags.includes(
                    'Disney100'
                )
            ) {
                console.log('here is Disney before', isDisney, currentProduct)
                setIsDisney(true)
            } else {
                setIsDisney(false)
            }

            if (
                currentProductFromVariants &&
                currentProductFromVariants[0] &&
                currentProductFromVariants[0].title.indexOf('SALE')
            ) {
                setIsBundle(false)
            }


            if (
                currentProductFromVariants &&
                currentProductFromVariants[0] &&
                currentProductFromVariants[0].tags.includes(
                    'UPF50'
                )
            ) {
                isUPF50 = true
            } else {
                isUPF50 = false
            }

            if (
                currentProductFromVariants &&
                currentProductFromVariants[0] &&
                currentProductFromVariants[0].tags.includes(
                    'fallsavingsevent2023'
                )
            ) {
                isSale30 = true
            } else {
                isSale30 = false
            }


            // if (
            //     currentProduct &&
            //     currentProduct[0] &&
            //     currentProduct[0].tags.includes('dailydeal')
            // ) {
            //     // console.log('here is Disney before', isDisney)
            //     setIsDailyDeal(true)
            // }

            // console.log('isDisney in swatch click', isDisney)

            let matchingVariantSizes = []

            matchingVariants.map((v) => {
                // console.log('v', v)
                if (v.initial_size && v.initial_size !== '') {
                    matchingVariantSizes.push({
                        variantId: v.id,
                        inventory_quantity: v.inventory_quantity,
                        sku: v.sku,
                        productId: v.product_id,
                        price: v.price,
                        initial_size: v.initial_size,
                    })
                }

                return null
            })

            matchingVariantSizes = getUniqueListBy(
                matchingVariantSizes,
                'initial_size'
            )

            matchingVariantSizes.map((s) => {
                // console.log('currentSize', currentSize)
                if (s.initial_size === currentSize) {
                    setCurrentSize(currentSize)
                } else {
                    setCurrentSize('')
                }
                return null
            })

            // console.log(
            //     'matchingVariants, matchingVariantSizes, currentSize',
            //     matchingVariants,
            //     matchingVariantSizes,
            //     currentSize
            // )

            setSizes(matchingVariantSizes)

            // console.log('currentSize', currentSize)

            if (
                currentSize.size &&
                currentSize.size !== null &&
                currentSize.size !== 'nosize'
            ) {
                let matchingVariant = matchingVariants.filter((v) => {
                    return v.initial_size === currentSize.size
                })

                if (matchingVariant && matchingVariant[0]) {
                    console.log('matchingVariant', matchingVariant)
                    insertUrlParam('variant', matchingVariant[0].id)
                    setCurrentPrice({
                        price: matchingVariant[0].price,
                        compareAtPrice: matchingVariant[0].compareAtPrice,
                    })
                    if (matchingVariant[0].inventory_quantities['1113980954']) {
                        if (
                            matchingVariant[0].inventory_quantities[
                                '1113980954'
                            ] > 0
                        ) {
                            embroidery = false
                        }
                    }
                }
            } else {
                console.log('no matching variant')

                let matchingVariantProductId = matchingVariants[0].product_id

                // currentProduct = products.filter((p) => {
                //     let currentP = p.variants.map((v) => {
                //         // console.log('v.id', v.id)
                //         if (
                //             v.id.toString() ===
                //             matchingVariantProductId.toString()
                //         ) {
                //             return p
                //         }
                //     })
                //     return currentP[0]
                // })

                // console.log(
                //     'matchingVariant after swatch click',
                //     matchingV,
                //     matchingV[0].inventory_quantities['61523329086']
                // )

                if (matchingV) {
                    insertUrlParam('variant', matchingV[0].id)
                    setCurrentPrice({
                        price: matchingV[0].price,
                        compareAtPrice: matchingV[0].compareAtPrice,
                    })
                } else {
                    setCurrentPrice({
                        price: matchingVariants[0].price,
                    })
                }

                if (
                    matchingV &&
                    matchingV[0].inventory_quantities &&
                    matchingV[0].inventory_quantities['61523329086'] &&
                    matchingV[0].inventory_quantities['61523329086'] > 0
                ) {
                    setEmbroidery(true)
                } else {
                    setEmbroidery(false)
                    console.log(
                        'no inventory quantities at XB after swatch click',
                        embroidery
                    )
                }

                let matchingProduct = products.filter((p) => {
                    return p.id === matchingVariantProductId
                })

                console.log(
                    'matchingProduct after swatch click',
                    matchingProduct
                )

                // if (
                //     matchingProduct &&
                //     matchingProduct[0] &&
                //     matchingProduct[0].tags.indexOf('dailydeal') > -1
                // ) {
                //     setIsDailyDeal(true)
                //     setIsRibbon(false)
                // } else {
                //     setIsDailyDeal(false)
                //     if (matchingProduct[0].vendor === 'Monica + Andy') {
                //         setIsRibbon(true)
                //     }
                // }

                if (matchingProduct && matchingProduct[0]) {
                    let matchingProductTags = matchingProduct[0].tags
                    intersection = tagsArray.filter((element) =>
                        matchingProductTags.includes(element)
                    )[0]
                    // console.log('intersection', intersection, hiddenProductTags)

                    if (
                        intersection &&
                        intersection !== '' &&
                        matchingProduct[0].title.indexOf('SALE') === -1 &&
                        !isDailyDeal
                    ) {
                        // console.log(
                        //     'here is sale, currentProduct, intersection',
                        //     currentProduct,
                        //     intersection
                        // )
                        setIsBundle(intersection)
                    } else {
                        setIsBundle(false)
                    }

                    let product = matchingProduct[0]

                    // console.log('product.title on swatch click', product.title)
                    const substrings = [
                        'bundle',
                        'duo',
                        'ribbed',
                        'trio',
                        'trunk-sale',
                        'Bundle',
                    ]

                    if (
                        product &&
                        product.vendor &&
                        product.vendor === 'Monica + Andy'
                    ) {
                        if (product.title.indexOf('FINAL FEW') > -1) {
                            setIsFinalFew(true)
                        } else {
                            // setIsRibbon(true)
                        }
                        let handle = product.handle
                        let title = product.title

                        // console.log('title in handleSwatchClick', title)

                        // let found

                        // if (substrings.some((w) => handle.includes(w))) {
                        //     found = true
                        // }

                        // if (
                        //     matchingProduct &&
                        //     matchingProduct[0] &&
                        //     matchingProduct[0].tags.indexOf('dailydeal') > -1
                        // ) {
                        //     setIsDailyDeal(true)
                        // }

                        if (product.title.indexOf('TRUNK SALE') === -1) {
                            setIsTrunkSale(false)
                        }

                        if (product.title.indexOf('SALE') === -1) {
                            setIsTrunkSale(false)
                            setIsFinalFew(false)
                        }

                        if (
                            product.title.indexOf('TRUNK SALE') > -1 ||
                            product.title.indexOf('FINAL FEW') > -1 ||
                            product.title.indexOf('SALE') > -1
                        ) {
                            setIsTrunkSale(true)
                            setIsRibbon(true)
                        }
                        // else if (
                        //     product &&
                        //     product[0] &&
                        //     product[0].tags.indexOf('dailydeal') === -1
                        // ) {
                        //     console.log('not daily deal', product)
                        //     setIsRibbon(true)
                        // }

                        if (
                                product &&
                                product[0] &&
                                product[0].tags.indexOf('summersavingsevent')
                            ) {
                                isSale40 = true
                            }
                    }
                }



                // console.log('matchingProduct', matchingProduct)


                // console.log(
                //     'matchingVariants[0] after swatch click',
                //     matchingVariants[0]
                // )
                setCurrentPrice({
                    price: matchingVariants[0].price,
                    compareAtPrice:
                        matchingVariants[0].compareAtPrice ||
                        matchingVariants[0].compare_at_price,
                })
                // update url param
                insertUrlParam('variant', matchingId)
                if (currentSize.size === 'nosize') {
                    setCurrentSize({
                        size: 'nosize',
                        variantId: matchingId,
                    })
                } else {
                    setCurrentSize({
                        size: '',
                        variantId: matchingId,
                    })
                }
            }
            let sizeSelector = document.getElementsByClassName('size-text')
            if (sizeSelector.length > 0) {
                let el = document.querySelectorAll('.registry-actions')
                el[0].firstChild.classList.add('disabled')
                el[0].firstChild.innerText = 'Add to Registry'
            }
        }

        const handleLightbox = () => {
            closeLightbox()
            if (videoIsActive) {
                closeLightbox()
                return
            }
            let imageSelected = document.querySelector('.image-selected')
            let currentIndex = imageSelected.dataset.index
            currentIndex = parseInt(currentIndex)
            openLightbox(currentIndex ? currentIndex : 0)
        }

        const handleSizeClick = (size, variantId, index, sku, inventory) => {
            // console.log('inventory', inventory)
            if (inventory === 0) {
                $('.disney-waitlist-outer').show()
                setSoldOutSelected({
                    isSoldOut: true,
                    variantId: variantId,
                    productTitle: hiddenProduct[0].title,
                    variantColor: currentColor,
                    variantSize: size,
                    variantSku: sku,
                })
            } else {
                setSoldOutSelected({
                    isSoldOut: false,
                    variantId: '',
                    productTitle: '',
                    variantColor: '',
                    variantSize: '',
                    variantSku: '',
                })
                insertUrlParam('variant', variantId)
                let el = document.querySelectorAll('.registry-actions')
                el[0].firstChild.innerText = 'Add to Registry'
                let ele = document.getElementsByClassName('size size-selected')
                if (ele.length > 0) {
                    ele[0].classList.remove('size-selected')
                }
                setCurrentSize({
                    size: size,
                    variantId: variantId,
                    sku: sku,
                })
            }
        }

        const handleQuantityDecrement = () => {
            if (quantity > 1) {
                setQuantity(quantity - 1)
            }
        }

        const handleQuantityChange = (e) => {
            if (e.target.value > 0) {
                setQuantity(e.target.value)
            }
        }

        const handleQuantityIncrement = () => {
            setQuantity(quantity + 1)
        }

        const handleMouseMove = (e, src) => {

            if (windowWidth < 768) {
                return
            }
            // console.log('e.target', e.target)
            const { left, top, width, height } =
                e.target.getBoundingClientRect()
            const x = ((e.pageX - left) / width) * 100
            const y = ((e.pageY - top) / height) * 100
            setMainImageStyle({
                backgroundImage: `url(${src})`,
                backgroundPosition: `${x}% ${y}%`,
            })
        }

        const handleVideoPlay = () => {
            closeLightbox()
            setVideoIsActive(!videoIsActive)
            videoRef.current.play()
            setVideoIsPlaying(true)
        }

        const handleVideoClick = () => {
            if (videoRef.current.paused) {
                videoRef.current.play()
                setVideoIsPlaying(true)
                setVideoIsActive(true)
            } else {
                videoRef.current.pause()
                setVideoIsPlaying(false)
                setVideoIsActive(false)
            }
        }

        const handleVideoEnd = () => {
            setVideoIsActive(!videoIsActive)
            setVideoIsPlaying(false)
        }

        const handlePlayPillClick = (e) => {
            e.preventDefault()
            e.stopPropagation()
            closeLightbox()
            setVideoIsActive(!videoIsActive)
            videoRef.current.play()
            setVideoIsPlaying(true)
        }

        const handleWaitlistSubmit = (e) => {
            $('.popup-success').hide()
            $('.popup-error').hide()

            // popup form functions
            var frm = $('#disney-waitlist-form')

            frm.submit(function (e) {
                e.preventDefault()

                $('#invalid_email').hide()

                var signupEmail = $('#disney-waitlist-email').val()
                // var signupFirstName = $('#disney-waitlist-first-name').val()
                // var signupLastName = $('#disney-waitlist-last-name').val()
                // var signupPhone = $('#disney-waitlist-phone').val()
                // var optIn = $('#disney-opt-in').is(':checked')

                // console.log('birthDate', birthDate)

                // simple email validation
                if (IsEmail(signupEmail) == false) {
                    $('#invalid_email').show()
                    return false
                }

                // if (IsPhone(signupPhone) == false) {
                //     $('#invalid_phone').show()
                //     return false
                // }

                // console.log('signupEmail', signupEmail)

                // const attentiveData = { email: signupEmail, phone: signupPhone }

                var settings = {
                    async: true,
                    crossDomain: true,
                    url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        'cache-control': 'no-cache',
                    },
                    data: {
                        g: 'YiwCyQ',
                        email: signupEmail,
                        $fields:
                            'phone, first_name, last_name, opt_in, form_source, oos_id, oos_title, oos_color, oos_size, oos_sku',

                        oos_title: hiddenProduct[0].title.replace(
                            '[hidden]',
                            ''
                        ),
                        oos_id: soldOutSelected.variantId,
                        oos_color: soldOutSelected.variantColor,
                        oos_size: soldOutSelected.variantSize,
                        oos_sku: soldOutSelected.variantSku,
                        // phone: signupPhone,
                        // opt_in: optIn,
                        form_source: 'Disney 100 Out Of Stock Waitlist PDP',
                        $source: 'Disney 100 Out Of Stock Waitlist PDP',
                    },
                }

                $.ajax(settings)
                    .done(function (response) {
                        console.log('response', response)

                        $('#disney-waitlist-form')[0].reset()

                        $('.popup-success').show()
                        $('.popup-error').hide()
                        $('.disney-waitlist-content').hide()
                        $('.disney-waitlist-success').css('display', 'flex')

                        // $.post(
                        //     `https://data.monicaandandy.com/attn/signup.php`,
                        //     attentiveData,
                        //     function (returnedData) {
                        //         // do something here with the returnedData
                        //         console.log(
                        //             'data server returned data',
                        //             returnedData
                        //         )
                        //     }
                        // )
                    })
                    .fail(function (error) {
                        console.log('error', error)
                        $('.popup-success').hide()
                        $('.popup-error').show()
                    })
                    .always(function () {
                        console.log('request complete')
                    })
            })

            function IsEmail(email) {
                var regex =
                    /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
                if (!regex.test(email)) {
                    return false
                } else {
                    return true
                }
            }

            function IsPhone(str) {
                var regex =
                    /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/
                if (!regex.test(str)) {
                    return false
                } else {
                    return true
                }
            }
        }

        const closeWaitlistForm = () => {
            $('.disney-waitlist-outer').hide()
        }

        const addProductToRegistry = async (
            title,
            imageUrl,
            currentVariantId,
            quantity,
            selectorId = undefined
        ) => {
            let itemUrl = window.location.href
            let itemDetail = {
                url: itemUrl,
                quantity: quantity,
                maRegistryImage: imageUrl,
                title: title,
            }
            let registries = getCookie('ma_registry_id')
            let token = getCookie('access_token')

            if (
                !(window.hasRegistry === 'True' || window.hasRegistry === true)
            ) {
                window.openRegistryModal(itemDetail)
                return
            }

            if (registries && !window.registryId) {
                let allRegistries = JSON.parse(decodeURIComponent(registries))
                if (allRegistries.length > 0) {
                    window.registryId =
                        allRegistries[allRegistries.length - 1].id
                }
            }

            if ((token || token.length) && !window.registryId) {
                await window.verifyToken(itemDetail)
            }

            if (window.registryId) {
                const ADD_REGISTRY_ITEM = `
                mutation addRegistryItemsByVariant($itemUrl: String!, $imageUrl: String!, $registryId: Int!, $title: String!, $quantity: Int!)
                { addRegistryItemsByVariant(itemUrl: $itemUrl, imageUrl: $imageUrl, registryId: $registryId, title: $title, quantity: $quantity) {
                    message
                    }
                }
            `

                const add_product_headers = {
                    'Content-Type': 'application/json',
                    Authorization: 'Token ' + getCookie('access_token'),
                }

                let reqData = {
                    query: ADD_REGISTRY_ITEM,
                    variables: {
                        itemUrl: itemUrl,
                        imageUrl: imageUrl,
                        registryId: Number(window.registryId),
                        title: title,
                        quantity: quantity,
                    },
                }

                let addProductToRegistry = fetch(window.graphqlEndpoint, {
                    method: 'POST',
                    headers: add_product_headers,
                    body: JSON.stringify(reqData),
                })

                addProductToRegistry
                    .then((res) => res.json())
                    .then((data) => {
                        let btnEl = document.querySelectorAll(
                            `.registry-btn[data-variant-id="${currentVariantId}"]`
                        )
                        if ((data.errors || data.error) && btnEl.length) {
                            btnEl.forEach(
                                (i) =>
                                    (i.innerHTML = 'Try adding after sometime')
                            )
                        } else {
                            localStorage.removeItem('maRePrURL')
                            if (selectorId) {
                                let spanButton = document.querySelector(
                                    '#' + selectorId
                                )
                                if (spanButton) {
                                    spanButton.innerHTML =
                                        'Item Added to Registry'
                                    spanButton.style.width = '60%'
                                    spanButton.style.color = '#2ea9be'
                                    // spanButton.style.w
                                }
                            } else if (btnEl.length) {
                                btnEl.forEach(
                                    (i) =>
                                        (i.innerHTML = 'Item Added to Registry')
                                )
                            }
                        }
                    })
                    .catch((err) => {
                        console.log('Error while adding product: ', err)
                        let btnEl = document.querySelectorAll(
                            `.registry-btn[data-variant-id="${currentVariantId}"]`
                        )
                        if (btnEl.length) {
                            btnEl.forEach(
                                (i) =>
                                    (i.innerHTML = 'Try adding after sometime')
                            )
                        }
                    })
            } else {
                window.openRegistryModal(itemDetail)
            }
        }

        const nullFunction = () => {}

        const handleOptions = (e, options) => {

            const embroideryData = data.embroidery
            const embroideryProducts = embroideryData.products

            let embroideryProduct = embroideryProducts.filter((p) => {
                return p.productHandle === slug
            })

            // console.log('e, options', e, options, e.target.name)
            let dataOption = e.target.getAttribute('data-option')

            // get the variantId of the product we are embroidering
            let variantId = document.getElementById('variant-id').value
            // console.log('variantId', variantId)

            // console.log('dataOption', dataOption)

            console.log('embroideryProduct in Product.js', embroideryProduct)

            let text
            let font
            let color
            let charLimit = embroideryProduct[0]?.characterLimit || 20


            if (e.target.name === 'addEmbroidery') {
                setProductOptions({
                    ...productOptions,
                    embroidery: !productOptions.embroidery,
                    embroideryVariantId: variantId,
                    embroideryCharacterLimit: charLimit,
                })
            }

            if (e.target.name === 'embroideryText') {
                text = e.target.value
                text = trimLeadingSpaces(text)

                console.log('text in embroidery', text)
                let font
                let monogram = false
                let athletic = false

                if (productOptions.embroideryFont) {
                    font = productOptions.embroideryFont
                }

                if (font && font.webName && font.webName === 'Monogram') {
                    monogram = true
                }

                if (font && font.webName && font.webName === 'Athletic') {
                    athletic = true
                }

                if (
                    (monogram && text.length > 0) ||
                    (athletic && text.length > 0)
                ) {
                    text = text.replace(
                        /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
                        ''
                    )
                }



                if (!monogram && !athletic) {
                    charLimit = embroideryProduct[0].characterLimit
                }

                if (monogram) {
                    charLimit = 3
                } else if (athletic) {
                    charLimit = 1
                }

                const optionsObj = {
                    ...productOptions,
                    embroideryText: text,
                    embroiderySubmitted: false,
                    embroideryCharacterLimit: charLimit,
                    embroideryError: {
                        ...embroideryError,
                        text: false,
                    },
                    // embroideryVerified: text.length > 0 ? true : false,
                }

                setProductOptions(optionsObj)

            }

            // if (e.target.name === 'embroideryTypeMonogram') {
            //     setProductOptions({
            //         ...productOptions,
            //         embroideryType: {
            //             monogram: true,
            //             text: false,
            //             single: false,
            //             mama: false,
            //         },
            //     })
            // }

            // if (e.target.name === 'embroideryTypeMama') {
            //     font = { webName: 'Mama', fontName: 'Angelface' }
            //     setProductOptions({
            //         ...productOptions,
            //         embroideryType: {
            //             monogram: false,
            //             text: false,
            //             single: false,
            //             mama: true,
            //         },
            //         embroideryText: 'Mama',
            //         embroideryFont: font,
            //     })
            // }

            // if (e.target.name === 'embroideryTypeText') {
            //     setProductOptions({
            //         ...productOptions,
            //         embroideryType: {
            //             monogram: false,
            //             text: true,
            //             single: false,
            //             mama: false,
            //         },
            //     })
            // }

            // if (e.target.name === 'embroideryTypeSingle') {
            //     setProductOptions({
            //         ...productOptions,
            //         embroideryType: {
            //             monogram: false,
            //             text: false,
            //             single: true,
            //             mama: false,
            //         },
            //     })
            // }

            // if (e.target.name === 'embroideryText') {
            //     text = e.target.value
            //     setProductOptions({
            //         ...productOptions,
            //         embroideryText: text,
            //     })
            // }

            if (dataOption && dataOption === 'embroideryFont') {
                font = {
                    webName: options.webName,
                    fontName: options.fontName,

                }

                let monogram = false
                let athletic = false

                if (font.webName === 'Monogram') {
                    monogram = true
                    athletic = false
                }

                if (font.webName === 'Athletic') {
                    athletic = true
                    monogram = false
                }

                // if (!monogram && !athletic) {
                //     charLimit = 20
                // }

                if (monogram) {
                    charLimit = 3
                } else if (athletic) {
                    charLimit = 1
                }

                console.log('monogram, athletic, charLimit', monogram, athletic, charLimit)

                let text = productOptions.embroideryText
                // let text2 = productOptions.embroideryText2
                let length = charLimit
                let trimmedString = ''
                let trimmedString2 = ''
                if (text) {
                    trimmedString = text.substring(0, length)
                }
                // if (text2) {
                //     trimmedString2 = text2.substring(0, length)
                // }
                if (monogram && trimmedString) {
                    trimmedString = trimmedString.replace(
                        /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
                        ''
                    )
                }

                if (monogram && trimmedString2) {
                    trimmedString2 = trimmedString2.replace(
                        /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
                        ''
                    )
                }

                console.log('charLimit', charLimit)

                // console.log(
                //     'trimmedString, trimmedString2',
                //     trimmedString,
                //     trimmedString2
                // )
                const optionsObj = {
                    ...productOptions,
                    embroideryFont: font,
                    embroideryText: text,

                    embroideryCharacterLimit: charLimit,
                    embroiderySubmitted: false,

                }
                setProductOptions(optionsObj)

            }

            // if (dataOption && dataOption === 'embroideryFont') {
            //     font = { webName: options.webName, fontName: options.fontName }
            //     setProductOptions({
            //         ...productOptions,
            //         embroideryFont: font,
            //     })
            // }

            if (dataOption && dataOption === 'embroideryColor') {
                color = { threadColor: options.threadColor, name: options.name }
                setProductOptions({
                    ...productOptions,
                    embroideryColor: color,
                })
            }

            if (dataOption && dataOption === 'embroiderySubmitted') {
                setProductOptions({
                    ...productOptions,
                    embroiderySubmitted: true,
                })
            }
        }

        const clearOptions = () => {
            setProductOptions({
                embroidery: false,
                embroideryCharacterLimit: 20,
                embroideryText: '',
                embroideryFont: {},
                embroideryColor: {},
                embroideryPrice: 15,
            })
            sessionStorage.removeItem('embroideryOptions')

            // document.getElementById('pdp-embroidery').scrollIntoView()
        }

        useEffect(() => {
            // get the variantId of the product we are embroidering
            const parsed = qs.parse(window.location.search)
            let variantId = parsed.variant
            // console.log('variantId', variantId)
            if (
                variantId &&
                productOptions &&
                productOptions.embroideryVariantId
            ) {
                if (
                    variantId.toString() === productOptions.embroideryVariantId
                ) {
                    sessionStorage.setItem(
                        'productOptions',
                        JSON.stringify(productOptions)
                    )
                } else {
                    sessionStorage.removeItem('productOptions')
                }
            }
            // console.log('productOptions', productOptions)
        }, [productOptions])

        const handleAddToCart = (e) => {
            e.preventDefault()

            // console.log(
            //     'productOptions.embroidery',
            //     productOptions.embroidery,
            //     productOptions
            // )

            if (
                productOptions.embroidery === true &&
                productOptions.embroiderySubmitted === false
            ) {
                setEmbroideryError(true)
                alert(
                    'Please select all required embroidery options and submit before adding to your cart.'
                )
                return
            } else {
                setEmbroideryError(false)
            }

            // if we don't have an embroidered product, bail
            if (productOptions.embroidery === false) {
                return
            }

            // get the variantId of the product we are embroidering
            let variantId = document.getElementById('variant-id').value
            variantId = parseInt(variantId)
            // console.log('variantId', variantId)

            // prepare data for Shopify
            let formData = {
                items: [
                    {
                        id: 39726235418686,
                        quantity: 1,
                        properties: {
                            variantId: variantId,
                            SKU: 'embroidery',
                        },
                    },
                    {
                        id: variantId,
                        quantity: quantity,
                        properties: {
                            'Add Embroidery?':
                                productOptions.embroidery === true
                                    ? '✓ Yes'
                                    : '',

                            Text:
                                productOptions.embroideryText !== ''
                                    ? productOptions.embroideryText
                                    : '',
                            'Web Font': productOptions.embroideryFont
                                ? productOptions.embroideryFont.webName
                                : '',
                            'Font Name': productOptions.embroideryFont
                                ? productOptions.embroideryFont.fontName
                                : '',
                            'Thread Color': productOptions.embroideryColor
                                ? productOptions.embroideryColor.threadColor
                                : '',
                            'Color': productOptions.embroideryColor
                                ? productOptions.embroideryColor.name
                                : '',
                            'Embroidery Price':
                                '$' + productOptions.embroideryPrice.toFixed(2),
                        },
                    },
                ],
            }

            console.log('formData', formData)

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            })
                .then((response) => {
                    console.log('response from cart/add', response)
                    clearOptions()
                    setTimeout(() => {
                        document.getElementById('open-cart-drawer').click()
                    }, 500)
                    return response.json()
                })
                .catch((error) => {
                    console.error('Error:', error)
                })

            // now using locale-based url
        }

        const ErrorHandler = ({ error }) => {
            return (
                <div role="alert">
                    <p>An error occurred:</p>
                    <pre>{error.message}</pre>
                </div>
            )
        }

        useEffect(() => {
            const scriptTag = document.createElement('script')
            scriptTag.src =
                'https://js.findmine.com/17DDBA6FE3F1E1CC7934.module.js'
            scriptTag.addEventListener('load', () => setLoaded(true))
            document.body.appendChild(scriptTag)
        }, [])

        useEffect(() => {
            if (loaded) {
                let params = {
                    application: '17DDBA6FE3F1E1CC7934',
                    product_price: currentPrice.price,
                    product_in_stock: true,
                    // product_id: hiddenProduct && hiddenProduct[0] ? hiddenProduct[0].id : currentProduct && currentProduct[0].id,
                    product_id:
                        currentProduct && currentProduct[0]
                            ? currentProduct[0].id
                            : mainProduct && mainProduct[0]
                            ? mainProduct[0].id
                            : currentProduct && currentProduct[0]
                            ? currentProduct[0].id
                            : null,
                    // product_id: 7037318299710,
                    return_pdp_item: true,
                    // product_color_id: currentColor,
                }

                setTimeout(() => {
                    window.FindMine.match(params)
                }, 1000)
            }
        }, [loaded, currentPrice.price, currentProduct, mainProduct])

        // useEffect(() => {
        //     setTimeout(() => {
        //         let swatchList = document.querySelector('.swatch-list')
        //         console.log('swatchList', swatchList, swatchList.childNodes)
        //         if (
        //             swatchList &&
        //             swatchList.childNodes &&
        //             swatchList.childNodes.length === 1
        //         ) {
        //             simulateMouseClick(swatchList.firstElementChild)
        //             console.log('The button has been clicked.')
        //         }
        //     }, 1000)
        // }, [])

        // async function simulateMouseClick(el) {
        //     let opts = {
        //         view: window,
        //         bubbles: true,
        //         cancelable: true,
        //         buttons: 1,
        //     }
        //     el.dispatchEvent(new MouseEvent('mousedown', opts))
        //     await new Promise((r) => setTimeout(r, 50))
        //     el.dispatchEvent(new MouseEvent('mouseup', opts))
        //     el.dispatchEvent(new MouseEvent('click', opts))
        // }

        // console.log('isUPF50', isUPF50)

        // console.log('isSale40', isSale40)

        console.log('isSale30', isSale30)

        return (
            <Fragment>
                <div className="product-outer main-product">
                    <div className="product-inner">
                        <div className="product-images-outer">
                            <div className="product-images-inner">
                                <div
                                    className={`nav-images ${
                                        video && video.length ? 'nav-video' : ''
                                    }`}
                                >
                                    {allProductImages &&
                                    allProductImages.length ? (
                                        <Fragment>
                                            {video && video.length ? (
                                                <VideoPlaceholder
                                                    image={
                                                        mainProduct &&
                                                        mainProduct[0]
                                                            .images_info
                                                            .length > 0
                                                            ? mainProduct[0]
                                                                  .images_info[0]
                                                            : allProductImages[0]
                                                    }
                                                    handleVideoPlay={
                                                        handleVideoPlay
                                                    }
                                                    videoIsActive={
                                                        videoIsActive
                                                    }
                                                />
                                            ) : null}
                                            <div
                                                className={`nav-prev nav-arrow ${
                                                    position.pos === 0
                                                        ? 'nav-disabled'
                                                        : null
                                                }`}
                                                onClick={handlePrevClick}
                                            >
                                                <CaretUp />
                                            </div>
                                            <div className="nav-images-wrap">
                                                <ul
                                                    id="images-nav"
                                                    className="images-nav nostyle"
                                                >
                                                    <SRLWrapper
                                                        options={options}
                                                    >
                                                        {currentImages &&
                                                            currentImages.map(
                                                                (n, i) => {
                                                                    // console.log(
                                                                    //     'n',
                                                                    //     n
                                                                    // )
                                                                    return (
                                                                        <li
                                                                            key={
                                                                                n.id
                                                                            }
                                                                            data-index={
                                                                                i
                                                                            }
                                                                            data-color={
                                                                                n.initial_color
                                                                            }
                                                                            className={`nav-image ${
                                                                                position.index ===
                                                                                i
                                                                                    ? 'image-selected'
                                                                                    : null
                                                                            }`}
                                                                            onClick={() =>
                                                                                handleImageClick(
                                                                                    n.colorSlug,
                                                                                    n.initial_color,
                                                                                    n.imageSrc,
                                                                                    n.imageAlt,
                                                                                    i
                                                                                )
                                                                            }
                                                                            title={
                                                                                n.initial_color
                                                                            }
                                                                        >
                                                                            <a
                                                                                href={
                                                                                    n.imageSrc
                                                                                }
                                                                            >
                                                                                <img
                                                                                    src={
                                                                                        n.imageSrc +
                                                                                        '&width=100'
                                                                                    }
                                                                                    alt={
                                                                                        n.initial_color
                                                                                    }
                                                                                />
                                                                            </a>
                                                                        </li>
                                                                    )
                                                                }
                                                            )}
                                                    </SRLWrapper>
                                                </ul>
                                            </div>
                                            <div
                                                className={`nav-next nav-arrow ${
                                                    position.index ===
                                                    allProductImages.length
                                                        ? 'nav-disabled'
                                                        : null
                                                }`}
                                                onClick={handleNextClick}
                                            >
                                                <CaretDown />
                                            </div>
                                        </Fragment>
                                    ) : (
                                        <div className="loading">Loading</div>
                                    )}
                                </div>
                                <div
                                    className={`product-image main-image ${
                                        videoIsActive
                                            ? 'main-image-video-active'
                                            : ''
                                    }`}
                                    onMouseMove={(e) =>
                                        handleMouseMove(
                                            e,
                                            mainImage ? mainImage.src : null
                                        )
                                    }
                                    style={mainImageStyle}
                                    onClick={handleLightbox}
                                >
                                    {mainImage ? (
                                        <Fragment>
                                            <img
                                                src={mainImage.src}
                                                alt={mainImage.alt}
                                                data-variant-id={
                                                    mainImage.variantId
                                                }
                                                data-color={
                                                    mainImage.initial_color
                                                }
                                                className="main-image-image"
                                            />

                                            {/* {isDailyDeal ? (
                                                <Ribbon
                                                    ribbonWidth="280px"
                                                    text="Daily Deal 50% Off"
                                                    backgroundColor="#AC7060"
                                                />
                                            ) : null} */}

                                            {/* {isRibbon ? (
                                                <div className="ribbon trunk-sale-ribbon">
                                                    <BF30OffInCart />
                                                </div>
                                            ) : null} */}
                                            {/* {isTrunkSale ? (
                                                <div className="ribbon trunk-sale-ribbon">
                                                    <Plus25Ribbon />
                                                </div>
                                            ) : null} */}

                                            {/* {isBundle ? (
                                                <div className="ribbon final-few-ribbon">
                                                    <BF30OffInCart />
                                                </div>
                                            ) : null} */}

                                            {/* {isBundle && (
                                                <div className="ribbon trunk-sale-ribbon">
                                                    <BundleRibbon
                                                        ribbon={
                                                            bundleRibbons[
                                                                isBundle
                                                            ]
                                                        }
                                                    />
                                                </div>
                                            )} */}

                                            {/* {isFinalFew ? (
                                                <div className="ribbon final-few-ribbon">
                                                    <BF30OffInCart />
                                                </div>
                                            ) : null} */}

                                            {/* {isSwim && (
                                                <div className="product-flag">
                                                    <BF30OffInCart />
                                                </div>
                                            )} */}

                                            {isUPF50 && (
                                                <div className="product-flag">
                                                    <UPF50 />
                                                </div>
                                            )}

                                            {isSale30 && !isDisney && (
                                                <div className="product-flag">
                                                    <BF30OffInCart />
                                                </div>
                                            )}

                                            {/* {isSale40 && (
                                                <div className="product-flag">
                                                    <Plus40Ribbon />
                                                </div>
                                            )} */}

                                            {/* {isMA && (
                                                <div className="product-flag">
                                                    <Sale25Ribbon />
                                                </div>
                                            )} */}

                                        </Fragment>
                                    ) : (
                                        <div className="loading">Loading</div>
                                    )}
                                    {video && video.length ? (
                                        <Fragment>
                                            <ProductVideo
                                                video={video}
                                                videoIsActive={videoIsActive}
                                                videoIsPlaying={videoIsPlaying}
                                                videoRef={videoRef}
                                                handleVideoEnd={handleVideoEnd}
                                                handleVideoClick={
                                                    handleVideoClick
                                                }
                                            />
                                            <span
                                                className="play-video"
                                                onClick={(e) => {
                                                    handlePlayPillClick(e)
                                                    setVideoIsActive(true)
                                                }}
                                            >
                                                ▶ Play Video
                                            </span>
                                        </Fragment>
                                    ) : null}
                                </div>
                            </div>
                            <div className="image-instruction">
                                Hover to zoom or click to view full image larger
                            </div>
                        </div>
                        <div className="product-content-outer">
                            <div className="product-content-inner">
                                <div className="product-header">
                                    <h1 className="product-title">
                                        {productTitle
                                            .split('_')[0]
                                            .replace('[hidden]', '')}
                                    </h1>
                                </div>
                                <div className="product-price">
                                    {currentPrice &&
                                        currentPrice.price !== 0 &&
                                        currentPrice.price !== '0' && (
                                            <span className="price">
                                                $
                                                {convertToCurrency(
                                                    currentPrice.price
                                                )}
                                            </span>
                                        )}
                                    {currentPrice &&
                                        currentPrice.compareAtPrice &&
                                        currentPrice.price !==
                                            currentPrice.compareAtPrice && (
                                            <span className="compare-at-price">
                                                $
                                                {convertToCurrency(
                                                    currentPrice.compareAtPrice
                                                )}
                                            </span>
                                        )}
                                    {(currentPrice.price === '0' ||
                                        currentPrice.price === 0) && (
                                        <span>Free</span>
                                    )}
                                    {slug &&
                                    slug.indexOf(
                                        'disney-princess-double-ruffle'
                                    ) > -1 ? (
                                        <div
                                            data-bv-show="rating_summary"
                                            data-bv-product-id="6933496070206"
                                        ></div>
                                    ) : (
                                        <div
                                            data-bv-show="rating_summary"
                                            data-bv-product-id={
                                                hiddenProduct &&
                                                hiddenProduct[0]
                                                    ? hiddenProduct[0].id
                                                    : mainProduct &&
                                                      mainProduct[0]
                                                    ? mainProduct[0].id
                                                    : currentProduct &&
                                                      currentProduct[0]
                                                    ? currentProduct[0].id
                                                    : null
                                            }
                                        ></div>
                                    )}
                                </div>
                                <div className="alternate-payments"></div>
                                <div className="product-actions product-actions-outer">
                                    <div className="product-actions-inner">
                                        <div className="product-quantity">
                                            <div className="product-quantity-label">
                                                Quantity:
                                            </div>
                                            <div className="product-quantity-wrap">
                                                <button
                                                    className={`quantity-decrement ${
                                                        quantity === 1
                                                            ? 'quantity-disabled'
                                                            : ''
                                                    }`}
                                                    onClick={
                                                        handleQuantityDecrement
                                                    }
                                                >
                                                    <span className="minus">
                                                        –
                                                    </span>
                                                </button>
                                                <input
                                                    className="quantity-input"
                                                    type="text"
                                                    value={quantity}
                                                    onChange={
                                                        handleQuantityChange
                                                    }
                                                />
                                                <button
                                                    className="quantity-increment"
                                                    onClick={
                                                        handleQuantityIncrement
                                                    }
                                                >
                                                    <span className="plus">
                                                        +
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="product-add-to-cart">
                                            <div className="product-add-to-cart">
                                                <button
                                                    id="open-cart-drawer"
                                                    className="hidden visually-hidden open-drawer"
                                                >
                                                    Open Cart
                                                </button>
                                                <form
                                                    action={`${
                                                        productOptions.embroidery ===
                                                        false
                                                            ? '/cart/add'
                                                            : ''
                                                    }`}
                                                    acceptCharset="UTF-8"
                                                    encType="multipart/form-data"
                                                    className="product-atc"
                                                >
                                                    <Fragment>
                                                        <input
                                                            type="hidden"
                                                            min="1"
                                                            name="quantity"
                                                            value={quantity}
                                                        />
                                                        <input
                                                            type="hidden"
                                                            name="id"
                                                            id="variant-id"
                                                            value={
                                                                currentSize.variantId
                                                                    ? currentSize.variantId
                                                                    : variants.length >
                                                                      0
                                                                    ? variants[0]
                                                                          .id
                                                                    : ''
                                                            }
                                                        />
                                                    </Fragment>
                                                    <img
                                                        src="https://tags.srv.stackadapt.com/conv?cid=qBKDsUM8E94E9aNhrIzfYt"
                                                        width="1"
                                                        height="1"
                                                    />
                                                    {windowWidth < 768 && !currentSize.size && (
                                                        <div className="mobile-size-error">
                                                            Please select a size
                                                        </div>
                                                    )}
                                                    <button
                                                        type={
                                                            !currentSize.size
                                                                ? null
                                                                : 'submit'
                                                        }
                                                        id="pdp-mainline-add-to-cart"
                                                        className={`large-button button-atc ${
                                                            !currentSize.size
                                                                ? 'disabled'
                                                                : ''
                                                        } ${
                                                            productOptions.embroidery &&
                                                            !productOptions.embroiderySubmitted
                                                                ? 'disabled'
                                                                : ''
                                                        }`}
                                                        // data-balloon-blunt
                                                        data-balloon-pos="up"
                                                        aria-label={
                                                            !currentSize.size
                                                                ? 'Please select a size'
                                                                : null
                                                        }
                                                        onClick={(e) =>
                                                            handleAddToCart(e)
                                                        }
                                                    >
                                                        Add To Cart
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="product-add-to-registry">
                                            <div className="registry-actions">
                                                <span
                                                    className={`large-button button-atc registry-btn ${
                                                        !currentSize.size
                                                            ? 'disabled'
                                                            : null
                                                    }`}
                                                    data-variant-id={
                                                        currentSize.variantId
                                                    }
                                                    data-balloon-blunt
                                                    data-balloon-pos="up"
                                                    aria-label={
                                                        !currentSize.size
                                                            ? 'Please select a size'
                                                            : null
                                                    }
                                                    onClick={() => {
                                                        if (!currentSize.size) {
                                                            nullFunction()
                                                        } else {
                                                            addProductToRegistry(
                                                                productTitle
                                                                    .split(
                                                                        '_'
                                                                    )[0]
                                                                    .replace(
                                                                        '[hidden]',
                                                                        ''
                                                                    ),
                                                                mainImage
                                                                    ? mainImage.src
                                                                    : null,
                                                                currentSize.variantId,
                                                                quantity
                                                            )
                                                        }
                                                    }}
                                                >
                                                    Add To Registry
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {colors !== 'No swatches' && (
                                    <div className="product-swatches">
                                        <div className="current-color-text">
                                            Selected Color:{' '}
                                            <span className="current-color-text-text">
                                                {currentColor && currentColor
                                                    ? currentColor
                                                    : ''}
                                            </span>
                                        </div>

                                        {colors && colors.basicColors ? (
                                            <div className="color-section">
                                                <div className="color-text">
                                                    Basics:{' '}
                                                </div>
                                                <ul
                                                    ref={inputRef}
                                                    className="swatch-list pattern-list nostyle"
                                                >
                                                    {colors.basicColors.map(
                                                        (s, i) => {
                                                            // console.log(
                                                            //     's',
                                                            //     s,
                                                            //     sortedColors.basic)
                                                            if (s && s.color) {
                                                                const swatchSlug =
                                                                    slugify(
                                                                        s.color
                                                                    )
                                                                return (
                                                                    <li
                                                                        key={
                                                                            swatchSlug
                                                                        }
                                                                        className={`swatch swatch-item ${
                                                                            currentColor &&
                                                                            currentColor ===
                                                                                s.color.replace(
                                                                                    /\//g,
                                                                                    ' '
                                                                                )
                                                                                ? 'swatch-selected'
                                                                                : ''
                                                                        }`}
                                                                        data-swatch-index={
                                                                            i
                                                                        }
                                                                        data-swatch-color={
                                                                            swatchSlug
                                                                        }
                                                                        aria-label={
                                                                            s.color
                                                                        }
                                                                        data-balloon-pos="up"
                                                                        onClick={() =>
                                                                            handleSwatchClick(
                                                                                swatchSlug,
                                                                                s.color,
                                                                                i
                                                                            )
                                                                        }
                                                                    >
                                                                        <div className="swatch-image">
                                                                            <img
                                                                                src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
                                                                                alt={
                                                                                    s.color
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </li>
                                                                )
                                                            }
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        ) : null}
                                        {colors && colors.limitedColors ? (
                                            <div className="color-section">
                                                <div className="color-text">
                                                    Limited Edition:{' '}
                                                </div>
                                                <ul
                                                    ref={inputRef}
                                                    className="swatch-list pattern-list nostyle"
                                                >
                                                    {colors.limitedColors.map(
                                                        (s, i) => {
                                                            const swatchSlug =
                                                                slugify(s.color)

                                                                // console.log('swatchSlug', swatchSlug)
                                                            return (
                                                                <li
                                                                    key={
                                                                        swatchSlug
                                                                    }
                                                                    className={`swatch swatch-item ${
                                                                        currentColor &&
                                                                        currentColor ===
                                                                            s.color.replace(
                                                                                /\//g,
                                                                                ' '
                                                                            )
                                                                            ? 'swatch-selected'
                                                                            : ''
                                                                    }`}
                                                                    data-swatch-index={
                                                                        i
                                                                    }
                                                                    data-swatch-color={
                                                                        swatchSlug
                                                                    }
                                                                    aria-label={
                                                                        s.color
                                                                    }
                                                                    data-balloon-pos="up"
                                                                    onClick={() =>
                                                                        handleSwatchClick(
                                                                            swatchSlug,
                                                                            s.color,
                                                                            i
                                                                        )
                                                                    }
                                                                >
                                                                    <div className="swatch-image">
                                                                        <img
                                                                            src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
                                                                            alt={
                                                                                s.color
                                                                            }
                                                                        />
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        ) : null}
                                        {colors && colors.trunkSaleColors ? (
                                            <div className="color-section">
                                                <div className="color-text">
                                                    Sale:{' '}
                                                </div>
                                                <ul
                                                    ref={inputRef}
                                                    className="swatch-list pattern-list nostyle"
                                                >
                                                    {colors.trunkSaleColors.map(
                                                        (s, i) => {
                                                            const swatchSlug =
                                                                slugify(s.color)
                                                                // console.log('swatchSlug sale', swatchSlug)
                                                            return (
                                                                <li
                                                                    key={
                                                                        swatchSlug
                                                                    }
                                                                    className={`swatch swatch-item ${
                                                                        currentColor &&
                                                                        currentColor ===
                                                                            s.color.replace(
                                                                                /\//g,
                                                                                ' '
                                                                            )
                                                                            ? 'swatch-selected'
                                                                            : ''
                                                                    }`}
                                                                    data-swatch-index={
                                                                        i
                                                                    }
                                                                    data-swatch-color={
                                                                        swatchSlug
                                                                    }
                                                                    aria-label={
                                                                        s.color
                                                                    }
                                                                    data-balloon-pos="up"
                                                                    onClick={() =>
                                                                        handleSwatchClick(
                                                                            swatchSlug,
                                                                            s.color,
                                                                            i
                                                                        )
                                                                    }
                                                                >
                                                                    <div className="swatch-image">
                                                                        <img
                                                                            src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
                                                                            alt={
                                                                                s.color
                                                                            }
                                                                        />
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        ) : null}
                                    </div>
                                )}

                                {soldOutSelected.isSoldOut && isDisney && (
                                    <div className="disney-waitlist-outer">
                                        <div className="disney-waitlist-inner">
                                            <span
                                                className="disney-waitlist-close"
                                                onClick={closeWaitlistForm}
                                            >
                                                &times;
                                            </span>
                                            <div className="disney-waitlist-content">
                                                <h2>
                                                    Get notified when product is
                                                    back in stock
                                                </h2>
                                                <p>
                                                    Product:{' '}
                                                    {hiddenProduct[0].title.replace(
                                                        '[hidden]',
                                                        ''
                                                    )}
                                                </p>
                                                <p>Color: {currentColor}</p>
                                                <p>
                                                    Size:{' '}
                                                    {
                                                        soldOutSelected.variantSize
                                                    }
                                                </p>
                                                <form
                                                    id="disney-waitlist-form"
                                                    action="/"
                                                >
                                                    <label
                                                        id="disney-waitlist-email-label"
                                                        htmlFor="disney-waitlist-email"
                                                    >
                                                        Email Address{' '}
                                                        <span className="required">
                                                            (required)
                                                        </span>
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            id="disney-waitlist-email"
                                                            required
                                                        />
                                                    </label>

                                                    <p className="disney-waitlist-terms">
                                                        * By submitting this
                                                        form you are agreeing to
                                                        receive marketing and
                                                        promotional emails from
                                                        Monica + Andy. You may
                                                        unsubscribe or opt-out
                                                        at any time. You will
                                                        still receive a message
                                                        if the item you
                                                        submitted is back in
                                                        stock.
                                                    </p>

                                                    <button
                                                        className="large-button primary-button"
                                                        type="submit"
                                                        onClick={(e) =>
                                                            handleWaitlistSubmit(
                                                                e
                                                            )
                                                        }
                                                    >
                                                        Notify Me
                                                    </button>
                                                </form>
                                            </div>
                                            <div className="disney-waitlist-success">
                                                <h2>You'll get notified!</h2>
                                                <p>Thanks for submitting.</p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="product-sizes">
                                    {sizes && sizes.length ? (
                                        <Fragment>
                                            <div className="size-text">
                                                Size:{' '}
                                                <span className="current-size-text">
                                                    {currentSize.size &&
                                                    currentSize.size !==
                                                        'nosize'
                                                        ? currentSize.size
                                                        : ''}
                                                </span>
                                                {isDisney && (
                                                    <span className="oos-text">
                                                        Click/tap on an
                                                        out-of-stock size to get
                                                        notified if it is back
                                                        in stock.
                                                    </span>
                                                )}
                                            </div>
                                            <ul className="size-list nostyle">
                                                {sizes.map((s, i) => {
                                                    // console.log('s', s)
                                                    if (
                                                        s.initial_size &&
                                                        s.initial_size !== ''
                                                    ) {
                                                        return (
                                                            <li
                                                                key={
                                                                    s.initial_size
                                                                }
                                                                className={`size ${
                                                                    currentSize.size &&
                                                                    currentSize.size ===
                                                                        s.initial_size
                                                                        ? 'size-selected'
                                                                        : ''
                                                                } ${
                                                                    s.inventory_quantity ===
                                                                    0
                                                                        ? 'size-out-of-stock'
                                                                        : ''
                                                                }`}
                                                                onClick={() =>
                                                                    handleSizeClick(
                                                                        s.initial_size,
                                                                        s.variantId,
                                                                        i,
                                                                        s.sku,
                                                                        s.inventory_quantity
                                                                    )
                                                                }
                                                                data-variant-id={
                                                                    s.variantId
                                                                }
                                                                aria-label={
                                                                    s.inventory_quantity ===
                                                                        0 &&
                                                                    isDisney
                                                                        ? 'Click to get notified when back in stock'
                                                                        : null
                                                                }
                                                                data-balloon-pos="up"
                                                            >
                                                                <span className="size-label">
                                                                    {
                                                                        s.initial_size
                                                                    }
                                                                </span>
                                                            </li>
                                                        )
                                                    }
                                                    return null
                                                })}
                                            </ul>
                                            <SizeGuide />
                                        </Fragment>
                                    ) : null}
                                </div>

                                {embroidery && (
                                    <Embroidery
                                        productOptions={productOptions}
                                        setProductOptions={setProductOptions}
                                        handleOptions={handleOptions}
                                        clearOptions={clearOptions}
                                        productHandle={
                                            hiddenProduct && hiddenProduct[0] &&
                                            hiddenProduct[0].handle ? hiddenProduct[0].handle : ''
                                        }
                                    />
                                )}

                                <div className="product-description">
                                    {!noGots ? (
                                        <div className="gots-certified-logo">
                                            <img
                                                src="https://cdn.shopify.com/s/files/1/2338/2917/files/gots-pdp-label_2x_47427d89-ebd8-4dd0-bcf7-9bf036469ed2.png?v=1663862365"
                                                alt="GOTS Certified Logo"
                                                className="gots-certified-logo-img"
                                            />
                                        </div>
                                    ) : null}

                                    <div className="product-desc">
                                        {productDescriptionText}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="findmine-app-container" />

                {mainProduct &&
                    mainProduct[0] &&
                    mainProduct[0].vendor === 'Monica + Andy' &&
                    slug && (
                        <div className="below-product-outer">
                            <div className="below-product-inner">
                                {slug.indexOf('disney-princess') === -1 &&
                                (slug.indexOf('pajamas') > -1 ||
                                    slug.indexOf('sleep-bags') > -1) ? (
                                    <Fragment>
                                        <ShopMore
                                            queryType="print"
                                            shopMoreTitle="Shop More Styles"
                                            mainProduct={mainProduct}
                                        />
                                    </Fragment>
                                ) : null}
                            </div>
                        </div>
                    )}

                <div className="product-reviews-outer">
                    <div className="product-reviews-inner">
                        {slug &&
                        slug.indexOf('disney-princess-double-ruffle') > -1 ? (
                            <div
                                data-bv-show="reviews"
                                data-bv-product-id="6933496070206"
                            ></div>
                        ) : (
                            <div
                                data-bv-show="reviews"
                                data-bv-product-id={
                                    hiddenProduct && hiddenProduct[0]
                                        ? hiddenProduct[0].id
                                        : mainProduct && mainProduct[0]
                                        ? mainProduct[0].id
                                        : currentProduct && currentProduct[0]
                                        ? currentProduct[0].id
                                        : null
                                }
                            ></div>
                        )}
                    </div>
                </div>
                <ErrorBoundary FallbackComponent={ErrorHandler}>
                    <Schema
                        mainProduct={mainProduct}
                        productTitle={productTitle}
                        productDescription={productDescriptionText}
                        sku={currentSize.sku}
                        mainImage={mainImage}
                        currentPrice={currentPrice}
                    />
                </ErrorBoundary>
            </Fragment>
        )
    }
)

export default Product
